import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en/translation.json'
import ja from './locales/ja/translation.json'

export const supportedLngs = {
  en: 'English',
  ja: '日本語',
}

const options: InitOptions = {
  // debug: process.env.NODE_ENV !== 'production', //必要に応じて設定してください
  detection: {
    caches: ['localStorage'],
    order: ['navigator'],
  },
  fallbackLng: 'ja',
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
  resources: {
    en: { translation: en },
    ja: { translation: ja },
  },
  returnEmptyString: false,
  supportedLngs: Object.keys(supportedLngs),
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(options)
